// Stub file for common/hook - parents app doesn't need most kids features

import { useCallback, useState } from "react";

// Stub for useManageAssets
export const useManageAssets = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [assets] = useState<any[]>([]);
  const [isLoading] = useState(false);

  const refreshAssets = useCallback(async () => {
    // No-op in parents
  }, []);

  const deleteAsset = useCallback(async (_assetId: number) => {
    // No-op in parents
  }, []);

  return {
    assets,
    isLoading,
    refreshAssets,
    deleteAsset,
  };
};

// Stub for useOpenCv
export const useOpenCv = (_options?: { setInitialized?: () => void }) => {
  // No-op in parents
};

// Stub for useCamera
export const useCamera = (_videoRef: React.MutableRefObject<HTMLVideoElement | null>) => {
  return {
    clicked: false,
    cameraIds: [],
    cameraIndex: 0,
    handleOpenCamera: () => Promise.resolve(),
    handleCloseCamera: () => {},
    toggleRecording: () => {},
    setClicked: () => {},
    handleSwitch: () => {},
  };
};

// Stub for useAssetCache
export const useAssetCache = () => {
  return {
    getAsset: (_url: string) => null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAsset: (_url: string, _data: any) => {},
    clearCache: () => {},
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onAssetSaved: (_uid: string, _asset: any) => {},
    onAssetDeleted: (_uid: string, _assetId: number, _fileSize?: number) => {},
  };
};

// Stub for useParentAssetCache
export const useParentAssetCache = () => {
  return {
    getAsset: (_url: string) => null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAsset: (_url: string, _data: any) => {},
    clearCache: () => {},
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onParentAssetSaved: (_uid: string, _asset: any) => {},
    onAssetDeleted: (_uid: string, _assetId: number, _fileSize?: number) => {},
    onParentAssetDeleted: (_uid: string, _assetId: number, _fileSize?: number) => {},
  };
};
